import React from 'react';
import { Image, Button, Icon, Responsive } from "semantic-ui-react";
import { I18n } from 'react-i18next';
import LanguageSwitch from './LanguageSwitch'

import logo from '../images/logo.png'
import { isMobile } from 'react-device-detect';

const logout = () => {
  delete window.localStorage.gwps
  window.location.replace('/')
}

const HomePage = () => (
  <I18n ns="translations">
    {
      (t) => (
        <div id="header" className={isMobile && 'mobile'}>
            <Image src={logo} style={{width: 100}}/>
            <div id="menu-right">
              <LanguageSwitch />
              <Responsive {...Responsive.onlyMobile}>
                <Button id="logout-button" circular icon onClick={logout}><Icon name="sign out" /></Button>
              </Responsive>
              <Responsive minWidth={Responsive.onlyTablet.minWidth}>
                <Button id="logout-button" icon onClick={logout}><Icon name="sign out" />{t('home:logout')}</Button>
              </Responsive>
            </div>
        </div>
      )
    }
  </I18n>
)

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/Header.js